/**
 * Utility function to scroll to the top of the page
 * Uses smooth scrolling for better user experience
 */
export const scrollToTop = (): void => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
};

/**
 * Utility function to scroll to the top of the page instantly
 * Use this when you need immediate scrolling without animation
 */
export const scrollToTopInstant = (): void => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'auto'
  });
};
